module.exports = __webpack_public_path__ + "img/image43.6f231168.png";